import { useScrollToTop } from "core/hooks/useScrollToTop";
import AppLayout from "core/layouts/AppLayout";
import BottomNavigation from "core/layouts/BottomNavigation";
import React from "react";
import AiChefHeader from "./AiChefHeader";
import Icon from 'core/assets/icons';

const AiChefPageWrapper = ({
  children,
  url,
  handleGoBack
}: {
  children: React.ReactNode,
  url: string,
  handleGoBack?: () => void
}) => {
  useScrollToTop()

  return (
    <AppLayout>
      <AiChefHeader handleGoBack={handleGoBack} />
      <div className={url ? 'bg-dark flex justify-center' : ''}>
        {url ? (
          <img
            src={url}
            alt="ImgDefault"
            className="w-full h-[300px] object-contain bg-dark"
          />
        ) : (
          <div className="animate-pulse flex w-full">
            <div className="h-[300px] w-full bg-gray-300">
              <div className="flex justify-center items-center h-full">
                <img
                  src={Icon.RecipeUploading}
                  width="40"
                  height="40"
                  alt="Icon BottomAiChef"
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {children}
      <BottomNavigation activeIndex={3}/>
    </AppLayout>
  );
};

export default AiChefPageWrapper;
